import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noIssueSourcesScrumTeam: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.no-issue-sources-scrum-team',
		defaultMessage: 'Associate this team with an issue source to view its sprints',
		description:
			'Text to show in place of sprints when the Scrum team is not associated with an issue source.',
	},
	noIssueSourcesKanbanTeam: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.no-issue-sources-kanban-team',
		defaultMessage: 'Associate this team with an issue source to view its iterations',
		description:
			'Text to show in place of sprints when the Kanban team is not associated with an issue source.',
	},
});
